import { Box } from 'reflexbox';
import styled, { css } from 'styled-components';

import { Breakpoint } from '@treams/treams-ui';

const Emoticon = styled(Box)<{ selected: boolean }>`
	text-align: center;
	opacity: ${(props) => (props.selected ? 1.0 : 0.5)};

	font-size: 24px;
	width: 32px;

	@media screen and (min-width: ${Breakpoint.Medium}) {
		font-size: 32px;
		width: 48px;
	}

	${(props) =>
		props.onClick &&
		css`
			cursor: pointer;
			&:hover {
				opacity: 1;
			}
		`};
`;

export default Emoticon;
